import styled from 'styled-components';

export const FormBlock = styled.div`
  margin-bottom: 48px;
`;

export const PassengerTitle = styled.h3`
  font-family: var(--font-family-base);
  font-size: 16px;
  font-weight: 600;
  color: var(--title-color);
  line-height: 1.5;
  margin-bottom: 16px;
`;

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: 14px;
  font-weight: 400;
  color: var(--text-color);
  letter-spacing: -0.8px;
  padding: 2px 0;
`;

export const Checkbox = styled.input`
  appearance: none;
  width: 18px;
  height: 18px;
  border: 2px solid var(--primary-color);
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:checked {
    background-color: var(--primary-color);
  }

  &:checked::after {
    content: '';
    position: absolute;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2.5px 2.5px 0;
    transform: rotate(45deg);
    margin-bottom: 2px;
  }
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;

  > * {
    flex: 1;
    width: auto;
    margin-top: 0;
    min-width: 0;
  }
`;
